import React, { Component } from 'react';
import ArticlePreview from './article-preview';

export default class ArticlesColumn extends Component {
  
  render() {

    // TODO: is this error path needed??
    if (this.props.loadedOk !== true) {
      // FIXME: Damon impl retry button here
      return (
        <div>
          There was a problem talking to the server.  Wait a minute for auto-retry or
          use the button below.
          {/*
          switch to real button and wire here for reload 
          <a href="#about" className="btn btn-primary js-scroll-trigger">Reload</a>
          */}

           <button onClick={() => this.updateWeather()} className="btn btn-danger btn-sm m-2">Reload now</button>
         </div>
      );
    } else {
      return (
          <React.Fragment>
            {this.props.articles.map(article =>
              <ArticlePreview
                key={article.id}
                {... article.frontMatter}
                lastModifiedTimeHuman={article.lastModifiedTimeHuman}
                lastModifiedTime={article.lastModifiedTime}
                createdTime={article.createdTime}
                createdTimeHuman={article.createdTimeHuman}
                relativeUrl={article.relativeUrl}
              />
            )}
          </React.Fragment>
      );
    }
  }

}
